module.exports = __webpack_public_path__ + "img/Logo_Olympique_de_Marseille.6aacd4ce.png";